import type { TRssDirectoryProviderId } from './rssDirectoryProvider'
import { isKnownRssDirectoryProvider } from './rssDirectoryProvider'

export interface IRssWallProviderTheme {
  /** CSS modifier class on the story wall root (e.g. g1-wall--provider-uol). */
  wallClass: string
  /** Text shown in the top-bar logo badge. */
  logoText: string
}

const RSS_WALL_PROVIDER_THEMES: Record<TRssDirectoryProviderId, IRssWallProviderTheme> = {
  'g1': {
    wallClass: 'g1-wall--provider-g1',
    logoText: 'g1'
  },
  'uol': {
    wallClass: 'g1-wall--provider-uol',
    logoText: 'UOL'
  },
  'ebc': {
    wallClass: 'g1-wall--provider-ebc',
    logoText: 'AB'
  },
  'folha': {
    wallClass: 'g1-wall--provider-folha',
    logoText: 'Folha'
  },
  'cnn-brasil': {
    wallClass: 'g1-wall--provider-cnn-brasil',
    logoText: 'CNN'
  },
  'jornal-de-brasilia': {
    wallClass: 'g1-wall--provider-jornal-de-brasilia',
    logoText: 'JBr'
  },
  'correio-braziliense': {
    wallClass: 'g1-wall--provider-correio-braziliense',
    logoText: 'CB'
  },
  'r7': {
    wallClass: 'g1-wall--provider-r7',
    logoText: 'R7'
  },
  'ge': {
    wallClass: 'g1-wall--provider-ge',
    logoText: 'ge'
  },
  'canaltech': {
    wallClass: 'g1-wall--provider-canaltech',
    logoText: 'CT'
  },
  'valor': {
    wallClass: 'g1-wall--provider-valor',
    logoText: 'Valor'
  }
}

const DEFAULT_RSS_WALL_PROVIDER_THEME = RSS_WALL_PROVIDER_THEMES.g1

export function getRssWallProviderTheme(providerId: string): IRssWallProviderTheme {
  if (isKnownRssDirectoryProvider(providerId)) {
    return RSS_WALL_PROVIDER_THEMES[providerId]
  }
  return DEFAULT_RSS_WALL_PROVIDER_THEME
}
